import React from 'react';

const EmailIcon = ({ disabled }) => <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
  <path d='M1.61328 3.55798L11.9993 13L22.3843 3.55898' stroke={disabled ? '#898989' : '#442E83'} strokeWidth='2' strokeMiterlimit='10' strokeLinecap='round' strokeLinejoin='round' />
  <path d='M21 3H3C1.89543 3 1 3.89543 1 5V19C1 20.1046 1.89543 21 3 21H21C22.1046 21 23 20.1046 23 19V5C23 3.89543 22.1046 3 21 3Z' stroke={disabled ? '#898989' : '#442E83'} strokeWidth='2' strokeMiterlimit='10' strokeLinecap='round' strokeLinejoin='round' />
</svg>;

export default EmailIcon;
